export const STORE_DRAFT = '@send/store-draft';
export const REMOVE_DRAFT = '@send/remove-draft';
export const REQUEST_SIGN_TRANSACTION = '@send/request-sign-transaction';
export const REQUEST_PUSH_TRANSACTION = '@send/request-push-transaction';
export const SEND_RAW = '@send/send-raw';
export const DISPOSE = '@send/dispose';
